<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->
<div class="table-block">
  <div class="recordRow">
    <div class="recordLabel">Name</div>
    <div id="merchantLegalName" class="recordValue">
      {{ merchant.merchantLegalName! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Phone Number</div>
    <div id="legalEntityPhoneNumber" class="recordValue">
      {{ merchant.legalEntityPhoneNumber! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Address1</div>
    <div id="legalAddressLine1" class="recordValue">
      {{ merchant.legalEntityAddress?.address1! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Address2</div>
    <div id="legalAddressLine2" class="recordValue">
      {{ merchant.legalEntityAddress?.address2! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">City</div>
    <div id="legalCity" class="recordValue">
      {{ merchant.legalEntityAddress?.city! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">State</div>
    <div id="legalState" class="recordValue">
      {{ merchant.legalEntityAddress?.state! | stateAbrrToName }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Zip</div>
    <div id="legalZip" class="recordValue">
      {{ merchant.legalEntityAddress?.zip! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Country</div>
    <div id="legalCountry" class="recordValue">
      {{ merchant.legalEntityAddress?.country! }}
    </div>
  </div>
</div>
